module.exports = __webpack_public_path__ + "img/home-world-best-banner-02.06a3de6a.jpg";